import { Concurso } from '../models/inicio.models';

export const CONCURSOS_MOCK: Concurso[] = [
  {
    id: 'C-001',
    nombre: 'Concurso Capital Humano 2026',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-03-01',
    fechaCierre: '2026-05-15',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-001',
    palabrasClave: ['capital', 'humano', 'becas'],
  },
  {
    id: 'C-002',
    nombre: 'Redes de Investigacion Estrategica',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-02-20',
    fechaCierre: '2026-04-30',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-002',
    palabrasClave: ['redes', 'estrategia', 'conocimiento'],
  },
  {
    id: 'C-003',
    nombre: 'Proyectos de Investigacion Asociativa',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Internacional',
    fechaApertura: '2026-01-18',
    fechaCierre: '2026-04-10',
    estado: 'cerrado',
    urlDetalle: 'https://www.anid.cl/concursos/c-003',
    palabrasClave: ['proyectos', 'asociativa', 'centros'],
  },
  {
    id: 'C-004',
    nombre: 'Innovacion para Instituciones Publicas',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Regional',
    fechaApertura: '2026-03-10',
    fechaCierre: '2026-06-01',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-004',
    palabrasClave: ['innovacion', 'instituciones', 'publicas'],
  },
  {
    id: 'C-005',
    nombre: 'Fondo I+D Territorial',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Regional',
    fechaApertura: '2026-02-12',
    fechaCierre: '2026-05-20',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-005',
    palabrasClave: ['territorial', 'fondo', 'i+d'],
  },
  {
    id: 'C-006',
    nombre: 'Transferencia Tecnologica Regional',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-01-05',
    fechaCierre: '2026-03-15',
    estado: 'cerrado',
    urlDetalle: 'https://www.anid.cl/concursos/c-006',
    palabrasClave: ['transferencia', 'tecnologica', 'regional'],
  },
  {
    id: 'C-007',
    nombre: 'Centros e Investigacion Asociativa 2026',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-03-08',
    fechaCierre: '2026-06-30',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-007',
    palabrasClave: ['centros', 'investigacion', 'asociativa'],
  },
  {
    id: 'C-008',
    nombre: 'Fortalecimiento de Consorcios Cientificos',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Internacional',
    fechaApertura: '2026-03-22',
    fechaCierre: '2026-07-10',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-008',
    palabrasClave: ['consorcios', 'cientificos', 'fortalecimiento'],
  },
  {
    id: 'C-009',
    nombre: 'Programa de Innovacion Colaborativa',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-04-02',
    fechaCierre: '2026-08-01',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-009',
    palabrasClave: ['innovacion', 'colaborativa', 'desarrollo'],
  },
  {
    id: 'C-010',
    nombre: 'Concurso de Redes Internacionales',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Internacional',
    fechaApertura: '2026-04-05',
    fechaCierre: '2026-08-10',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-010',
    palabrasClave: ['redes', 'internacional', 'cooperacion'],
  },
  {
    id: 'C-011',
    nombre: 'Fondo de Investigacion Aplicada Regional',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Regional',
    fechaApertura: '2026-04-08',
    fechaCierre: '2026-08-20',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-011',
    palabrasClave: ['fondo', 'regional', 'aplicada'],
  },
  {
    id: 'C-012',
    nombre: 'Impulso a Centros de Excelencia',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Nacional',
    fechaApertura: '2026-04-12',
    fechaCierre: '2026-08-30',
    estado: 'abierto',
    urlDetalle: 'https://www.anid.cl/concursos/c-012',
    palabrasClave: ['centros', 'excelencia', 'impulso'],
  },
];
